export default __webpack_public_path__ + "static/media/Spider_Square_White_Top_1.c1efdb6f.jpeg";